<style lang="less">
.component{

}
</style>

<template>
	<!-- Main component -->
	<section class="component">
		{{detail.content}}
	</section>
</template>

<script>
	/*
		global  androidJs
	*/
	import android from '@flyme/jr/js/android.js';
	import axios from '../axios.js';

	export default {
		data: function () {
			return {
				detail: {}
			};
		},
		components: {
		},
		mounted: function () {
			android('hideLoadingDialog');
			console.log(1);
			this.getDetail();
		},
		methods: {
			getDetail: function () {
				let _this = this;
				axios.post(decodeURIComponent(this.$route.query.url), {}).then(function(d) {
					console.log('text', d);
					_this.detail = d.value;
				}).catch(function () {
					androidJs.doAndroidAction('showNoNetwork', '');
				});
			},
		}
	};
</script>


// WEBPACK FOOTER //
// src/pages/Rich_text.vue